import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Chip, Typography } from "@mui/material";
import BoxMedia from "../../items/fragments/BoxMedia.js";
import QuillEditor from "../../lib/quill/QuillEditor.js";

const MediaArticleComponent = ({ item, match, onTagClick }) => {
    const { title, content, imageUrl, timer, period, creation } = item;
    const [isPortrait, setIsPortrait] = useState(false);

    useEffect(() => {
      if (!imageUrl) return;
  
      const imageObject = new Image();
      imageObject.src = imageUrl;
  
      imageObject.onload = () => {
        setIsPortrait(imageObject.width <= imageObject.height);
      };
    }, [imageUrl]);

    useEffect(() => {
      // Vérifier si le script est déjà présent dans le DOM
      const existingScript = document.getElementById("twitterScript");
    
      if (!existingScript) {
        // Si le script n'existe pas, l'ajouter
        const script = document.createElement("script");
        script.src = "https://platform.twitter.com/widgets.js";
        script.async = true;
        script.id = "twitterScript";
    
        document.body.appendChild(script);
      }
    
      // Nettoyage si nécessaire
      return () => {
        // Ne pas retirer le script si d'autres composants en ont encore besoin
        // (Tu peux laisser le script en place pour éviter de le retirer inutilement)
      };
    }, []);

    const isQuillContent = useMemo(() => {
      if (!content || typeof content !== "string") return false;
      const regex = /^<(?!iframe|blockquote)/; // L'expression régulière vérifie que la chaîne commence par '<' mais pas par 'iframe' ou 'blockquote'
      return regex.test(content);
    }, [content]);

    const renderHTML = useCallback((rawHTML) => {
      const divStyle = {
        fontFamily: 'Source Sans Pro', // Ajoutez votre famille de polices ici
      };
    
      return React.createElement("div", { style: divStyle, dangerouslySetInnerHTML: { __html: rawHTML } });
    }, []);

    return (
      <BoxMedia media={item} match={match} onTagClick={onTagClick}>
        <Typography variant="mediaH2" component="div" sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}>{title}</Typography>

        {/** Si 'content' commence par '<' mais pas par '<iframe' ou '<blockquote' ==> alors c'est du quill content */}
        {
          isQuillContent && content ? 
          <QuillEditor theme="snow"
                content={content}
                readOnly={true}
                modules={{toolbar : null}}
            />
            :
            <>
              {renderHTML(content)}
              {imageUrl && (
                <img
                  src={imageUrl}
                  style={isPortrait ? { maxWidth: '100%', maxHeight: 600 } : { width: '100%' }}
                  alt="article"
                />
              )}
            </>
        }
  
      </BoxMedia>
    );
  };

  // On ne rerender le composant que si le content a changé
const MediaArticle = React.memo(MediaArticleComponent, (prev, next) => {
  return (
    prev.item._id === next.item._id &&
    prev.item.content === next.item.content &&
    prev.item.title === next.item.title &&
    prev.item.imageUrl === next.item.imageUrl &&
    JSON.stringify(prev.item.tags || []) === JSON.stringify(next.item.tags || [])
  );
});

  export default MediaArticle;